export default __webpack_public_path__ + "static/media/Vanir Bloodied Band.69401b8f.jpg";